import './CompteExpert.scss';

import { ArrowForward } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import SaveIcon from '@mui/icons-material/Save';
import {FormControlLabel, IconButton, Radio, RadioGroup } from '@mui/material';
import Button from '@mui/material/Button';
import { ThemeProvider } from '@mui/material/styles';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams} from 'react-router-dom';

import { buttonStyles, buttonStylesBlue } from '../../../Components/docsAdministrative/JsObjectStyles';
import RegimeModeTravail from '../../../Components/shared/RegimeModeTravail';
import { DatePickerComponent, IconTextField, SelectComponent, TextFieldComponent } from '../../../Components/shared/ReusableSmallComponents';
import SearchCityByRegions from '../../../Components/shared/SearchCityByRegions';
import { secteurActiviteEnum } from '../../../data/Interfaces';
import useAuth from '../../../hooks/useAuth';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import useCraRdv from '../../../hooks/useCraRdv';
import useFormValidation from '../../../hooks/useFormValidation';
import usePostRequest from '../../../hooks/usePostRequest';
import useRole from '../../../hooks/useRole';
import useUtilities from '../../../hooks/useUtilities';
import useWindowSize from '../../../hooks/useWindowSize';
import { FieldComponentFont } from '../../../Styles/componentStyles';
import { CompareTwoString, isHttpStatusSuccess, isUrlFromCompleterProfile } from '../../../Utils/utils';
import { typeTraitementEnum } from '../CompleterProfile/DonneesPersonnelsExpert';

function PreferenceGeneralise({typeTraitement , isDoCandidat}) {

    PreferenceGeneralise.propTypes = {
        typeTraitement:PropTypes.any,
        isDoCandidat : PropTypes.any,
    };
    const { expertToBeCreated, setExpertToBeCreated } = useCraRdv();
    const {postData, postDataSilently} = usePostRequest();
    const { auth, setAuth } = useAuth();
    const { inputSize } = useWindowSize();
    const axiosPrivate = useAxiosPrivate();
    const location = useLocation();
    const {isCandidat}=location.state || {};
    const isDossierCandidat= (isDoCandidat ?? isCandidat);
    console.log('isDoCandidat',isDoCandidat,'isCandidat',isCandidat);
    let param = useParams();
    const navigate = useNavigate();
    const {device}=useWindowSize();

    const [dataExpert, setDataExpert] = useState();
    const { i18n } = useTranslation();
    // const [isDossierCandidat,setIsDossierCandidat]= useState();
    const [modeTravail, setModeTravail] = React.useState({
        type: '',
        nbJrsRemotePerWeek: '',
    });
    const [regimeTravail, setRegimeTravail] = React.useState({
        type: '',
        nbJrsPartielPerWeek: '',
    });

    const { setBackdropOpen, setRemoteCountriesData, setShowErrors, setErrors} = useUtilities();
    const currentPath = location?.pathname.split('/').pop();
    const [inputListMobilite, setInputListMobilite] = useState([]);
    const [sector, setSector] = useState('');
    const [tauxJournalier, setTauxJournalier] = useState();
    const [salaireMens, setSalaireMens] = useState();
    const [inputListTitre, setInputListTitre] = useState([{ titre: '' }]);
    const [paysResidence, setPaysResidence] = useState('');
    const [regionResidence, setRegionResidence] = useState('');
    const [villeResidence, setVilleResidence] = useState('');
    const [dateDisponibility, setDateDisponibility] = useState(moment(Date.now()));
    const [disponibilite, setDisponibilite] = useState('aSpecifier');
    const [firstDataFromBackend, setFirstDataFromBackend] = useState();
    const [CheckUpdateValue, setCheckUpdateValue] = useState(true);
    const authorizedTypes = [
        typeTraitementEnum.ADMIN_ADD_EXPERT,
        typeTraitementEnum.COLLAB_ESN_ADD_EXPERT,
        typeTraitementEnum.COLLAB_ESN_ADD_DOSSIER_CANDIDAT
    ];

    function isAuthorizedType(typeTraitement) {
        return authorizedTypes.includes(typeTraitement);
    }
    // const [searchParams] = useSearchParams();
    const role = useRole();
    const target = useRef(null);
    // * required field declaration
    const [isValid] = useFormValidation([
        { name: 'disponibilite', value: disponibilite },
        { name: 'paysResidence', value: paysResidence },
        { name: 'regionResidence', value: regionResidence },
        { name: 'villeResidence', value: villeResidence },
    ]);
    useEffect(() => {
        if(typeTraitement)
            searchInfoExpert();
    }, [typeTraitement]);

    useEffect(() => {
        if (dataExpert) {
            initializePreferenceData(dataExpert?.preference);
        }
    }, [dataExpert]);

    // useEffect(() => {
    //     if(searchParams.get('isDossierCandidat') === 'true' && role=='esn')
    //         setIsDossierCandidat(true);
    //     else if (searchParams.get('isDossierCandidat') === 'false' && role=='esn')
    //         setIsDossierCandidat(false);
    // }, [searchParams]);

    // const getQueryParam = (param) => {
    //     const url = window.location.href; // Get the full URL
    //     const queryString = url.split('?')[1]; // Get everything after the "?"
    //     const params = new URLSearchParams(queryString); // Parse the query string
    //     return params.get(param); // Return the value of the parameter
    // };
    // const isDossierCandidat = getQueryParam('isDossierCandidat');

    const initializePreferenceData = (savedExpertPreference) => {
        console.log('firstDataFromBackend',firstDataFromBackend);
        console.log('savedExpertPreference',savedExpertPreference);
        setModeTravail({type: savedExpertPreference?.modeTravail?.type,nbJrsRemotePerWeek: savedExpertPreference?.modeTravail?.nbJrsRemotePerWeek});
        setRegimeTravail({type: savedExpertPreference?.regimeTravail?.type,nbJrsPartielPerWeek:savedExpertPreference?.regimeTravail?.nbJrsPartielPerWeek});

        //setMode(savedExpertPreference?.modeTravail?.type);
        //setTemps(savedExpertPreference?.regimeTravail?.type);
        let tempTitres = [];
        savedExpertPreference?.searchedPostes.map((x) => {
            tempTitres.push({ 'titre': x });
        });
        setInputListTitre(tempTitres);
        if(savedExpertPreference?.dateDisponibilite){
            setDisponibilite(savedExpertPreference?.dateDisponibilite?.type);
            setDateDisponibility(savedExpertPreference?.dateDisponibilite?.date);
        }
        setSalaireMens(savedExpertPreference?.tmm ?? '');
        setTauxJournalier(savedExpertPreference?.tjm ?? '');
        //setTitrePoste(savedExpertPreference?.searchedPostes);

        setSector(savedExpertPreference?.secteurActivite);
        // SearchCityByRegion
        setPaysResidence(savedExpertPreference?.residence?.pays);
        setRegionResidence(savedExpertPreference?.residence?.region);
        setVilleResidence(savedExpertPreference?.residence?.ville);
        if (Array.isArray(savedExpertPreference?.mobilite)) {
            setInputListMobilite(savedExpertPreference?.mobilite);
        }
        else
            setInputListMobilite([]);
        setCheckUpdateValue(true);
    };

    const handleInputChangeTitre = (e, index) => {
        const { name, value } = e.target;
        const list = [...inputListTitre];
        if (!CompareTwoString(list[index][name], value)) {
            setCheckUpdateValue(false);
        }
        list[index][name] = value;
        setInputListTitre(list);
    };

    const handleKeyDown = (event) => {
        if (event.key === '-') {
            event.preventDefault();
        }
    };

    const searchInfoExpert = async () => {
        if (typeTraitement==typeTraitementEnum.EXPERT_UPDATE || typeTraitement==typeTraitementEnum.EXPERT_COMPLETE_PROFILE) {
            setBackdropOpen(true);
            try {
                const response = await axiosPrivate.get('expert/getMyInfos');
                setDataExpert(response?.data?.expert);
                setFirstDataFromBackend(response?.data?.expert);
            } catch (error) {
                console.log(error);
            }
            setBackdropOpen(false);
        }
        if (typeTraitement==typeTraitementEnum.READ_ONLY || typeTraitement==typeTraitementEnum.ADMIN_UPDATE_EXPERT || typeTraitement==typeTraitementEnum.COLLAB_ESN_UPDATE_DOSSIER_CANDIDAT || typeTraitement==typeTraitementEnum.COLLAB_ESN_UPDATE_EXPERT) {
            setBackdropOpen(true);
            try {
                const response = await axiosPrivate.get('/users/getExpertById/' + param.ExpertId);
                setDataExpert(response?.data);
                setFirstDataFromBackend(response?.data);
            } catch (error) {
                console.log(error);
            }
            setBackdropOpen(false);
        }
    };

    async function executeRequests(requestsToExecute) {
        const requestKeysInOrder = ['AddExpertStep1', 'AddExpertStep2_ResumeUpload', 'AddExpertStep2', 'AddExpertStep3'];
        let expertId;
        for (const key of requestKeysInOrder) {
            const request = requestsToExecute[key];
            const { url, payload } = request;
            console.log('from executeRequests', key, request);
            if (url && payload) {
                // the formData payload was a function that takes in input an expertId, but now I change this sol
                if (typeof payload === 'function' || payload instanceof FormData) {
                    // add expertId to FormData
                    if(expertId){
                        payload.append('expertId', expertId);
                        try {
                            const response = await postDataSilently({ url, payload });
                            // if the payload is a function, it's the AddExpertStep2_ResumeUpload request
                            // const formData = new FormData();
                            // formData.append('file', payload());
                            // formData.append('expertId', expertId);
                            // console.log('hola', url, payload);
                            // const response = await postData({url, formData});
                            console.log(response);
                        // expertId = response.expertId;
                        } catch (error) {
                            console.log(error);
                            break;
                        }
                    }
                } else {
                    // for all other requests, add the expertId to the payload and send the request
                    payload.expertId = expertId;// { ...payload, expertId }
                    try {
                        // expertId = response.expertId;
                        if (key === 'AddExpertStep1') {
                            const response = await postData({ url, payload });
                            expertId = response.data?.expert?._id;
                            console.log('ExpertID set', expertId);
                        }
                        // * the rest of the request which doesn't has formData
                        else await postDataSilently({ url, payload });
                    } catch (error) {
                        console.log(error);
                        break;
                    }
                }
            }
        }

        /*here is the object requests: {AddExpertStep1
        :
        {url: '/expert/completePersoData', payload: {…}}
        AddExpertStep2
        :
        {url: '/expert/storeCVData', payload: {…}}
        AddExpertStep2_ResumeUpload
        :
        expertId => {…}
        AddExpertStep3
        :
        {url: '/expert/completePreference', payload: {…}}
        AddExpertStep4
        :
        {url: '/expert/completeSociete', payload: FormData}},  I want a way to call them by this order :
        AddExpertStep1, AddExpertStep2_ResumeUpload,AddExpertStep2,AddExpertStep3,  AddExpertStep4 */
        // *
        // let expertId;

        // for (const [key, value] of Object.entries(requestsToExecute)) {
        //     let payload = value.payload;
        //     // check if payload is defined before modifying it
        //     if (payload && expertId) {
        //         if (payload instanceof FormData) {
        //             // add expertId to FormData
        //             payload.append('expertId', expertId);
        //         } else {
        //             // add expertId to simple object
        //             payload.expertId = expertId;
        //         }
        //     } else {
        //         // handle the case where payload is undefined
        //         console.log('Payload is undefined', payload);
        //     }
        //     console.log('from executeRequests', key, value, value.url, payload);

        //     const response = await postData(value.url, payload);

        //     if (key === 'AddExpertStep1') {
        //         expertId = response.expertId;
        //     }
        // }
    }

    const completePreference = async () => {
        try {
            let temp = [];
            inputListTitre.map(x => {
                temp.push(x.titre);
            });
            let tempDisponibilite = dateDisponibility;
            if (disponibilite == 'immediate')
                tempDisponibilite = moment(Date.now());
            const backendObject = {
                modeTravail,
                regimeTravail,
                mobilite: inputListMobilite,
                expertId:location?.state?.expertId ||param.ExpertId,
                //dateDisponibilite:tempDisponibilite,
                dateDisponibilite: {
                    type: disponibilite,
                    date: tempDisponibilite,
                },
                residence: {
                    ville: villeResidence,
                    region: regionResidence,
                    pays: paysResidence,
                },
                tjm: tauxJournalier,
                tmm: salaireMens,
                secteurActivite: sector,
                ...(role === 'esn' && isDossierCandidat==true ? { isDossierCandidat: isDossierCandidat } : {}),
                searchedPostes: temp,
                isFromAccountCompletion: isUrlFromCompleterProfile(location?.pathname),
            };
            if(isAuthorizedType(typeTraitement)){
                console.log('typeTraitement',typeTraitement);
                // setExpertToBeCreated({
                //     ...expertToBeCreated,
                //     AddExpertStep3:{ url: '/expert/completePreference', payload: backendObject }
                // });
                const response = await executeRequests({ ...expertToBeCreated, AddExpertStep3:{ url: '/expert/completePreference', payload: backendObject }});
                console.log('expertToBeCreated',expertToBeCreated,'response',response);
                setExpertToBeCreated(null);
                if(role=='esn' && isDossierCandidat==true)
                    navigate('/esn/gestionDossiersCandidats', { replace: true });
                else if(role=='esn' && isDossierCandidat==false)
                    navigate('/esn/gestionExperts', { replace: true });
                else
                    navigate('/admin/AddExpertStep4', { replace: true });

            }
            else {
                setBackdropOpen(true);
                const response = await postData({ url: '/expert/completePreference', payload:backendObject });
                if(isHttpStatusSuccess(response.responseStatus)){
                    console.log('expert updated', response?.data?.expert);
                    setFirstDataFromBackend(response?.data?.expert);
                    setCheckUpdateValue(true);
                    // if(typeTraitement==typeTraitementEnum.ADMIN_ADD_EXPERT){
                    //     navigate('/admin/AddExpertStep4', {
                    //         state: {
                    //             // resumeData will take time
                    //             expertId: response?.data?.expert?._id,
                    //         },
                    //     });
                    // }
                    navigateToNextStep();
                }
            }
            target?.current.focus();
        } catch (error) {
            console.log(' update error', error);
        }
    };

    // Get the form element
    const navigateToNextStep = () => {
        if (isUrlFromCompleterProfile(location?.pathname)){
            if(auth.completeStep < 4){
                // * Update the complete step to 4
                setAuth({ ...auth, completeStep: 4 });
            }
            // * clear the data from context API to free Space + performance ( 2Mo+)
            setRemoteCountriesData([]);
            navigate('/expert/completeProfile/step4');
            setBackdropOpen(false);
        }
    };

    return (
        <form style={{ display: 'flex',padding:device=='desktop'?'0px':'16px',width:device=='desktop'?'80%':'100%',minWidth:device=='desktop'?'514px':'200px',maxWidth:'900px'}}>
            <div className='frame1preference'>
                <div className='frame2preference'>
                    <h4 className='titlesociete'>
                        {i18n.t('Préférences')}
                    </h4>
                </div>
                {/* {messageAlert && (<div><Alert severity="error">{messageAlert}</Alert></div>)} */}
                <div className='frame3preference'>
                    <div className='frame4preference'>
                        <label className='labelsociete'>{i18n.t('Titre du poste recherché')}</label>
                        {inputListTitre.map((x, i) => (
                            <div
                                className='frame04preference'
                                key={i}
                            >
                                <div style={{ flex: 'none', display: 'flex', flexDirection: 'row', alignSelf: 'stretch' }}>
                                    <TextFieldComponent
                                        id="outlined-size-small"
                                        disabled={typeTraitement==typeTraitementEnum.READ_ONLY ? true : false}
                                        value={x.titre}
                                        name='titre'
                                        sx={{
                                            '& > :not(style)': { borderRadius: '8px' },
                                        }}
                                        onChange={(e) => {
                                            handleInputChangeTitre(e, i);
                                        }}
                                        style={{ width: '100%' ,borderRadius: '8px' }}
                                    />
                                    {typeTraitement!=typeTraitementEnum.READ_ONLY &&
                                            <IconButton
                                                onClick={() => {
                                                    setCheckUpdateValue(false);
                                                    setInputListTitre([
                                                        ...inputListTitre.slice(0, i),
                                                        ...inputListTitre.slice(i + 1, inputListTitre.length),
                                                    ]);
                                                }}
                                            >
                                                <DeleteForeverIcon />
                                            </IconButton>
                                    }
                                </div>
                            </div>
                        ))}
                    </div>
                    {typeTraitement!=typeTraitementEnum.READ_ONLY &&
                            <div className='frame5preference'>
                                <p
                                    className='Ajouterpreference'
                                >
                                    <IconButton
                                        onClick={() => {
                                            if (inputListTitre.length < 3) {
                                                setCheckUpdateValue(false);
                                                setInputListTitre([...inputListTitre, { titre: '' }]);
                                            }
                                        }}
                                    >
                                        <AddIcon />
                                    </IconButton>
                                    {i18n.t('Ajouter (3 nombre maximum d\'entrées)')}</p>
                            </div>
                    }
                </div>
                <div className='frame11preference'>
                    <h6 className='nomPrenomProfile'>{i18n.t('Disponibilité *')}</h6>
                    <div style={{ display: 'flex', flexDirection:device=='desktop'?'row':'column', gap: '4px', width: '100%' }}>
                        <RadioGroup
                            value={disponibilite}
                            name='disponibilite'
                            style={{ display: 'flex', flexDirection: 'row',alignSelf: 'stretch', width: device=='desktop'?'75%':'100%',gap:'4px' }}
                            onChange={(e) => {
                                if (!CompareTwoString(e.target.value, firstDataFromBackend?.preference?.dateDisponibilite?.type))
                                    setCheckUpdateValue(false);
                                setDisponibilite(e.target.value);
                                if (e.target.value == 'immediate')
                                    setDateDisponibility(moment(Date.now()));
                            }}
                        >
                            <div
                                style={{
                                    boxSizing: 'border-box',
                                    alignItems: 'center',
                                    //height: '40px',
                                    padding: inputSize == 'small' ? '0px  8px' : '8px 16px',
                                    height: inputSize == 'small' ? '40px' : '56px',
                                    //gap: '4px',
                                    width: device=='desktop'?'32.1%' :'100%',
                                    background: '#FFFFFF',
                                    border: '1px solid #9D9E9F',
                                    borderRadius: '8px',
                                }}
                            >
                                <ThemeProvider theme={FieldComponentFont}>
                                    <FormControlLabel
                                        value="immediate"
                                        control={<Radio />}
                                        label={i18n.t('Immédiate')}
                                        disabled={typeTraitement==typeTraitementEnum.READ_ONLY ? true : false}
                                    />
                                </ThemeProvider>
                            </div>
                            <div
                                style={{
                                    boxSizing: 'border-box',
                                    padding: inputSize == 'small' ? '0px  8px' : '8px 16px',
                                    gap: '4px',
                                    height: inputSize == 'small' ? '40px' : '56px',
                                    whiteSpace: 'nowrap',
                                    width: device=='desktop'?'33%' :'100%',
                                    background: '#FFFFFF',
                                    border: '1px solid #9D9E9F',
                                    borderRadius: '8px',
                                }}
                            >
                                <ThemeProvider theme={FieldComponentFont}>
                                    <FormControlLabel
                                        value="nonDispo"
                                        control={<Radio />}
                                        label={i18n.t('Non disponible')}
                                        disabled={typeTraitement==typeTraitementEnum.READ_ONLY ? true : false}
                                    />
                                </ThemeProvider>
                            </div>
                            <div
                                style={{
                                    boxSizing: 'border-box',
                                    padding: inputSize == 'small' ? '0px  8px' : '8px 16px',
                                    gap: '4px',
                                    height: inputSize == 'small' ? '40px' : '56px',
                                    whiteSpace: 'nowrap',
                                    width: device=='desktop'?'33%' :'100%',
                                    background: '#FFFFFF',
                                    border: '1px solid #9D9E9F',
                                    borderRadius: '8px',
                                }}
                            >
                                <ThemeProvider theme={FieldComponentFont}>
                                    <FormControlLabel
                                        value="aSpecifier"
                                        control={<Radio />}
                                        label={i18n.t('En une date')}
                                        disabled={typeTraitement==typeTraitementEnum.READ_ONLY ? true : false}
                                    />
                                </ThemeProvider>
                            </div>
                        </RadioGroup>
                        <DatePickerComponent
                            className="col-auto"
                            label=""
                            date={dateDisponibility}
                            setDate={(newValue) => {
                                if (!CompareTwoString(newValue,
                                    firstDataFromBackend?.preference?.dateDisponibilite))
                                    setCheckUpdateValue(false);
                                setDateDisponibility(newValue);
                            }}
                            disabled={(disponibilite == 'immediate' || typeTraitement==typeTraitementEnum.READ_ONLY) ? true : false}
                            width={device=='desktop' ?'25%':'100%'}
                            disablePast
                        />
                    </div>
                </div>

                <div className='frame6preference'>
                    <h6 className='nomPrenomProfile'>{i18n.t('Type de travail')}</h6>
                    <RegimeModeTravail
                        setModeTravail={setModeTravail}
                        setRegimeTravail={setRegimeTravail}
                        modeTravail={modeTravail}
                        setCheckUpdateValue={setCheckUpdateValue}
                        regimeTravail={regimeTravail}
                        mode={typeTraitement}
                    />
                </div>
                <div className='frame11preference'>
                    <h6 className='nomPrenomProfile'>{i18n.t('Lieu de résidence *')}</h6>
                    <div className='frame1222preference'>
                        <SearchCityByRegions
                            paysLocalisation={paysResidence}
                            setPaysLocalisation={setPaysResidence}
                            regionLocalisation={regionResidence}
                            setRegionLocalisation={setRegionResidence}
                            villeLocalisation={villeResidence}
                            setVilleLocalisation={setVilleResidence}
                            setCheckUpdateValue={setCheckUpdateValue}
                            // * those are simple html names to be passed for the required logic
                            namePays='paysResidence'
                            nameRegion='regionResidence'
                            nameVille='villeResidence'
                            mode={typeTraitement}
                        />
                    </div>
                </div>
                <div className='frame11preference'>
                    <h6 className='nomPrenomProfile'>{i18n.t('Mobilité professionnelle')}</h6>
                    <div className='frame12preference'>
                        <div className='frame15preference'>
                            {inputListMobilite.map((mobilite, i) => (
                                <div
                                    //className='frame015preference'
                                    style={{
                                        display: 'flex',
                                        flexDirection: device=='desktop' ?'row':'column',
                                        alignItems: 'flex-start',
                                        padding: '0px',
                                        width: '100%',
                                        gap: '8px'
                                    }}
                                    key={i}
                                >
                                    <SearchCityByRegions
                                        paysLocalisation={mobilite?.pays}
                                        setPaysLocalisation={(Value2Set) => {
                                            let newArr = [...inputListMobilite];
                                            newArr[i].pays = Value2Set;
                                            setInputListMobilite(newArr);
                                        }}
                                        regionLocalisation={mobilite?.region}
                                        setRegionLocalisation={(Value2Set) => {
                                            console.log(Value2Set);
                                            let newArr = [...inputListMobilite];
                                            newArr[i].region = Value2Set;
                                            setInputListMobilite(newArr);
                                        }}
                                        villeLocalisation={mobilite?.ville}
                                        setVilleLocalisation={(Value2Set) => {
                                            console.log(Value2Set);
                                            let newArr = [...inputListMobilite];
                                            newArr[i].ville = Value2Set;
                                            setInputListMobilite(newArr);
                                        }}
                                        mode={typeTraitement}
                                    />

                                    {typeTraitement!=typeTraitementEnum.READ_ONLY &&
                                            <IconButton
                                                onClick={() => {
                                                    setInputListMobilite( [
                                                        ...inputListMobilite.slice(0, i),
                                                        ...inputListMobilite.slice(i + 1, inputListMobilite.length),
                                                    ]);
                                                    setCheckUpdateValue(false);
                                                }}
                                            >
                                                <DeleteForeverIcon />
                                            </IconButton>
                                    }
                                </div>
                            ))}
                        </div>
                        {typeTraitement!=typeTraitementEnum.READ_ONLY &&
                                <div className='frame16preference'>
                                    <p className='Ajouterpreference'>
                                        <IconButton
                                            onClick={() => {
                                                setCheckUpdateValue(false);
                                                setInputListMobilite([...inputListMobilite, { pays: '', region: '', ville: '', state: [], cities: [], country: [] }]);
                                            }}
                                        >
                                            <AddIcon />
                                        </IconButton> {i18n.t('Ajouter')}
                                    </p>
                                </div>
                        }
                    </div>
                </div>
                <div className='frame17preference'>
                    <h6 className='nomPrenomProfile'>{i18n.t('Rémunération')}</h6>
                    <div className='frame18preference'>
                        <div className='frame19preference'>
                            <label className='label19preference'>{i18n.t('Taux journalier moyen')}</label>
                            <IconTextField
                                id="outlined-size-small"
                                //placeholder='00/jour'
                                disabled={typeTraitement==typeTraitementEnum.READ_ONLY ? true : false}
                                value={tauxJournalier}
                                type='number'
                                //error={(tauxJournalier >0) ? false : true}
                                //helperText={(tauxJournalier ? ((tauxJournalier>0) ? '' :'Veuillez entrer une valeur positive'):'')}
                                //onKeyDown={handleKeyDown}
                                onChange={(e) => {
                                    if (!CompareTwoString(e.target.value, tauxJournalier))
                                        setCheckUpdateValue(false);
                                    setTauxJournalier(e.target.value);
                                }}
                                onKeyDown={handleKeyDown}

                                iconEnd={'€'}
                                sx={{
                                    '& > :not(style)': { borderRadius: '8px' },
                                }}
                                //size="small"
                                InputProps={{
                                    inputProps: { min: 0,},
                                }}
                                style={{ width: '100%' ,borderRadius: '8px' }}
                            />

                        </div>
                        <div className='frame20preference'>
                            <label className='label19preference'>{i18n.t('Salaire mensuel moyen')}</label>
                            <IconTextField
                                id="outlined-size-small"
                                //placeholder='00/mois'
                                type='number'
                                value={salaireMens}
                                disabled={typeTraitement==typeTraitementEnum.READ_ONLY ? true : false}
                                onChange={(e) => {
                                    if (!CompareTwoString(e.target.value, salaireMens))
                                        setCheckUpdateValue(false);
                                    setSalaireMens(e.target.value);
                                }}
                                sx={{
                                    '& > :not(style)': { borderRadius: '8px' },
                                }}
                                onKeyDown={handleKeyDown}
                                //error={(salaireMens >0) ? false : true}
                                //helperText={(salaireMens ? ((salaireMens>0) ? '' :'Veuillez entrer une valeur positive'):'')}
                                iconEnd={'€'}
                                InputProps={{
                                    inputProps: { min: 0,},
                                    //endAdornment: (<div className='iconStyleStartAdornment iconStyleEndAdornment'><InputAdornment position="end">€</InputAdornment></div>),

                                }}

                                //size="small"
                                style={{ width: '100%' ,borderRadius: '8px' }}
                            />
                        </div>
                    </div>
                </div>
                <div className='frame21preference'>
                    <h6 className='titreframe21preference'>{i18n.t('Secteur d\'activité (facultatif)')}</h6>
                    <SelectComponent
                        val={sector}
                        disabled={typeTraitement==typeTraitementEnum.READ_ONLY ? true : false}
                        setVal={(event) => {
                            if (!CompareTwoString(event.target.value, sector)) {
                                setCheckUpdateValue(false);
                            }
                            setSector(event.target.value);
                        }}
                        listVal={secteurActiviteEnum}
                    />
                </div>
                {( typeTraitement==typeTraitementEnum.ADMIN_UPDATE_EXPERT || typeTraitement==typeTraitementEnum.EXPERT_UPDATE || typeTraitement==typeTraitementEnum.COLLAB_ESN_UPDATE_DOSSIER_CANDIDAT || typeTraitement==typeTraitementEnum.COLLAB_ESN_UPDATE_EXPERT)&& currentPath != 'step3' &&
                        <div style={{ display: 'flex', flexDirection:device=='desktop'?'row':'column', justifyContent: 'space-between', alignSelf: 'stretch' }}>
                            <Button
                                variant="text"
                                style={{...buttonStyles()}}
                                onClick={() => { initializePreferenceData(firstDataFromBackend?.preference); }}
                            >
                                {i18n.t('Annuler')}
                            </Button>
                            <Button
                                variant="contained"
                                style={{...buttonStylesBlue(CheckUpdateValue)}}
                                startIcon={<SaveIcon />}
                                disabled={CheckUpdateValue}
                                onClick={(e)=>{
                                    e.preventDefault();
                                    if (isValid) {
                                        completePreference();
                                        setShowErrors(false);
                                        setErrors({});
                                    }
                                    else{
                                        setShowErrors(true);
                                    }
                                }}
                            >
                                {i18n.t('Sauvegarder')}
                            </Button>
                        </div>
                }
                {typeTraitement!=typeTraitementEnum.ADMIN_UPDATE_EXPERT && typeTraitement!=typeTraitementEnum.EXPERT_UPDATE && typeTraitement!=typeTraitementEnum.COLLAB_ESN_UPDATE_DOSSIER_CANDIDAT && typeTraitement!=typeTraitementEnum.COLLAB_ESN_UPDATE_EXPERT && currentPath == 'step3' &&
                        <div style={{ display: 'flex', flexDirection: device=='desktop'?'row':'column', justifyContent: 'space-between', alignSelf: 'stretch',gap:device=='desktop'? '0px':'16px' }}>
                            <Button
                                variant="outlined"
                                style={{...buttonStyles(),...{order:device=='desktop'?'0' :'1'}}}
                                onClick={() => {
                                    setRemoteCountriesData([]);
                                    navigate('/expert');
                                }}
                            >
                                {i18n.t('Remplir plus tard')}
                            </Button>
                            <Button
                                variant="contained"
                                style={{...buttonStylesBlue(),...{order:device=='desktop'?'1':'0'}}}
                                startIcon={<ArrowForward />}
                                ref={target}
                                onClick={(e)=>{
                                    e.preventDefault();
                                    if (isValid) {
                                        completePreference();
                                        setShowErrors(false);
                                        setErrors({});
                                    }
                                    else{
                                        setShowErrors(true);
                                    }
                                }}
                            >
                                {i18n.t('Valider')}
                            </Button>
                        </div>
                }
                {(isAuthorizedType(typeTraitement)) &&
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignSelf: 'stretch' }}>
                            <Button
                                variant="contained"
                                style={{...buttonStylesBlue()}}
                                startIcon={<ArrowForward />}
                                onClick={(e)=>{
                                    e.preventDefault();
                                    if (isValid) {
                                        console.log('yes');
                                        completePreference();
                                        setShowErrors(false);
                                        setErrors({});
                                    }
                                    else{
                                        setShowErrors(true);
                                    }
                                }}
                            >
                                {i18n.t('Suivant')}
                            </Button>
                        </div>
                }
            </div>
        </form>
    );
}

export default PreferenceGeneralise;
